/* eslint-disable import/prefer-default-export */
import { ApiResponse } from '../@types';
import { request } from '../../utils';
import { TUSCounties, TUSDistricts, TUSStateCities, TUSStateCitiesResponse } from './@types';

let usStatesPromise: Promise<ApiResponse<TUSStateCities[]>> | null = null;

export const getUSStates = (): Promise<ApiResponse<TUSStateCities[]>> => {
  if (!usStatesPromise) {
    usStatesPromise = request({
      url: 'us-states',
      method: 'GET',
    });
  }
  return usStatesPromise;
};

export const getUSStateCities = (
  stateName: string,
): Promise<ApiResponse<TUSStateCitiesResponse>> => {
  return request({
    url: 'us-states-cities',
    method: 'GET',
    params: {
      stateName,
    },
  });
};

export const getSchoolsByState = ({ state, search }: any): Promise<ApiResponse<any>> => {
  return request({
    url: 'school-by-state',
    method: 'GET',
    params: {
      state,
      search,
    },
  });
};

export const getCounties = async (states: any): Promise<ApiResponse<TUSCounties[]>> => {
  return request({
    url: 'counties-by-state',
    method: 'POST',
    data: {
      states,
    },
  });
};

export const getDistricts = async (states: any): Promise<ApiResponse<TUSDistricts[]>> => {
  return request({
    url: 'districts-by-state',
    method: 'POST',
    data: {
      states,
    },
  });
};
